<template>
  <div>
    <icon-view
      class="mr-2 mt-3 rounded-circle icon-view-color-text"
      icon="fas fa-file-plus mb-1"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Documentos"
      :gradient="true"
    />
    <div class="py-4">
      <div
        class="mt-3"
        v-for="(item, index) in documents"
        :key="`document-index-${index}`"
      >
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Documento:</div>
              <div class="color-black font-16">
                {{ item.documentTypeName | empty }}
              </div>
            </div>
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Archivo:</div>
              <div class="color-black font-16">
                {{ item.fileName | empty }}
              </div>
            </div>
            <div
              class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
            >
              <action-button
                :id="`download-btn-${index}`"
                v-if="canDownloadFile(item)"
                class="btn-action-size ml-2"
                i="fas fa-file-download"
                variant="success"
                @click="onDownloadHandler(item)"
              />
              <action-button
                :id="`replace-btn-${index}`"
                v-if="canDownloadFile(item) && !readOnly"
                class="px-1 btn-action-size ml-2"
                i="fas fa-undo-alt"
                variant="outline-success"
                @click="onUploadHandler(item)"
              />
              <action-button
                :id="`download-btn-${index}`"
                v-if="!canDownloadFile(item) && !readOnly"
                class="px-1 btn-action-size ml-2"
                i="fas fa-file-plus"
                variant="outline-success"
                @click="onUploadHandler(item)"
              />
              <input
                id="file"
                ref="fileRef"
                type="file"
                style="display: none"
                accept="application/pdf"
                @change="onUploadFileHandler(item)"
              />
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import IconView from "icon-view";
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";

// Utils
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

export default {
  name: "registrationDocumentsInformation",
  mixins: [alertMixin],
  components: {
    IconView,
    CustomCallout,
    ActionButton,
  },
  computed: {
    canDownloadFile() {
      return (item) => item && item.documentId;
    },
  },
  props: {
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async onUploadHandler(item) {
      const itemIndex = _.findIndex(this.documents, (x) => x === item);
      this.$refs.fileRef[itemIndex].click();
    },
    async onDownloadHandler(item) {
      this.$emit("download", item);
    },
    async onUploadFileHandler(item) {
      const itemIndex = _.findIndex(this.documents, (x) => x === item);
      let files = this.$refs.fileRef[itemIndex].files;
      if (files.length > 0) {
        this.$emit("upload", item, files[0]);
        await this.$forceUpdate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.btn-action-size {
  width: 35px;
  height: 35px;
}

::v-deep .btn-action-size > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}
</style>
